import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    InputType,
    ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_2205_emp_profile_add: any[] = [
    {
      "componentType": "screenGroup",
      "title": "",
      "style": {},
      "childComponents": [
        {
          "componentType": "custom",
          "customType": "profileForm",
          "props": {
            "moduleName": "emp_profile_add",
            "tabs": [
              "about",
              "profile",
              "job",
              "documents",
              "assets",
              "salary",
              "leave"
            ],
            "tabConfigs": {
              "about": {
                "visibility": [
                  1,
                  2
                ],
                "sections": [
                  {
                    "sectionId": "primary_details",
                    "title": "Primary Details",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "primary_first_name",
                        "label": "First Name",
                        "placeholder": "Enter first name",
                        "inputType": "text",
                        "required": true,
                        "maxLength": 100,
                        "Json_Attribute": "first_name",
                        "BindValue": "primary_first_name",
                        "columnNumber": "m1 t2 w3",
                        "validation": [
                          {
                            "rule": "required",
                            "message": "First Name is required"
                          },
                          {
                            "rule": "maxLength",
                            "value": 100,
                            "message": "First Name must be at most 100 characters"
                          }
                        ]
                      },
                      {
                        "componentType": "textField",
                        "name": "primary_middle_name",
                        "label": "Middle Name",
                        "placeholder": "Enter middle name",
                        "inputType": "text",
                        "maxLength": 100,
                        "Json_Attribute": "middle_name",
                        "BindValue": "primary_middle_name",
                        "columnNumber": "m1 t2 w3",
                        "validation": [
                          {
                            "rule": "maxLength",
                            "value": 100,
                            "message": "Middle Name must be at most 100 characters"
                          }
                        ]
                      },
                      {
                        "componentType": "textField",
                        "name": "primary_last_name",
                        "label": "Last Name",
                        "placeholder": "Enter last name",
                        "inputType": "text",
                        "required": true,
                        "maxLength": 100,
                        "Json_Attribute": "last_name",
                        "BindValue": "primary_last_name",
                        "columnNumber": "m1 t2 w3",
                        "validation": [
                          {
                            "rule": "required",
                            "message": "Last Name is required"
                          },
                          {
                            "rule": "maxLength",
                            "value": 100,
                            "message": "Last Name must be at most 100 characters"
                          }
                        ]
                      },
                      {
                        "componentType": "textField",
                        "name": "primary_name",
                        "label": "Name",
                        "placeholder": "Auto-generated from First, Middle, and Last Name",
                        "inputType": "text",
                        "required": true,
                        "isReadOnly": true,
                        "disabled": true,
                        "Json_Attribute": "name",
                        "BindValue": "primary_name",
                        "columnNumber": "m1 t2 w3",
                        "validation": [
                          {
                            "rule": "required",
                            "message": "Name is required"
                          }
                        ]
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "primary_gender",
                        "label": "Gender",
                        "placeholder": "Select gender",
                        "options": [
                          {
                            "label": "Male",
                            "value": "male"
                          },
                          {
                            "label": "Female",
                            "value": "female"
                          },
                          {
                            "label": "Other",
                            "value": "other"
                          }
                        ],
                        "Json_Attribute": "gender",
                        "BindValue": "primary_gender",
                        "lookupName": "gender",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "primary_date_of_birth",
                        "label": "Date of Birth",
                        "placeholder": "Select date",
                        "required": true,
                        "PreventFutureDateSelection": true,
                        "Json_Attribute": "date_of_birth",
                        "BindValue": "primary_date_of_birth",
                        "columnNumber": "m1 t2 w3",
                        "validation": [
                          {
                            "rule": "required",
                            "message": "Date of Birth is required"
                          }
                        ]
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "primary_marital_status",
                        "label": "Marital Status",
                        "placeholder": "Select status",
                        "options": [
                          {
                            "label": "Single",
                            "value": "single"
                          },
                          {
                            "label": "Married",
                            "value": "married"
                          },
                          {
                            "label": "Divorced",
                            "value": "divorced"
                          },
                          {
                            "label": "Widowed",
                            "value": "widowed"
                          }
                        ],
                        "Json_Attribute": "marital_status",
                        "BindValue": "primary_marital_status",
                        "lookupName": "marital_status",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "primary_marriage_date",
                        "label": "Marriage Date",
                        "placeholder": "Select date",
                        "Json_Attribute": "marriage_date",
                        "BindValue": "primary_marriage_date",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "searchableDropdown",
                        "name": "primary_nationality",
                        "label": "Nationality",
                        "placeholder": "Select nationality",
                        "searchable": true,
                        "Json_Attribute": "nationality",
                        "BindValue": "primary_nationality",
                        "lookupName": "country",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "primary_languages_read",
                        "label": "Languages Known - Read",
                        "placeholder": "e.g., English, Malayalam",
                        "inputType": "text",
                        "Json_Attribute": "languages_read",
                        "BindValue": "primary_languages_read",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "primary_languages_write",
                        "label": "Languages Known - Write",
                        "placeholder": "e.g., English, Malayalam",
                        "inputType": "text",
                        "Json_Attribute": "languages_write",
                        "BindValue": "primary_languages_write",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "primary_languages_speak",
                        "label": "Languages Known - Speak",
                        "placeholder": "e.g., English, Malayalam, Tamil",
                        "inputType": "text",
                        "Json_Attribute": "languages_speak",
                        "BindValue": "primary_languages_speak",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "primary_physically_handicapped",
                        "label": "Physically Handicapped",
                        "placeholder": "Select",
                        "options": [
                          {
                            "label": "Yes",
                            "value": "yes"
                          },
                          {
                            "label": "No",
                            "value": "no"
                          }
                        ],
                        "Json_Attribute": "physically_handicapped",
                        "BindValue": "primary_physically_handicapped",
                        "lookupName": "physically_handicapped",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "searchableDropdown",
                        "name": "primary_blood_group",
                        "label": "Blood Group",
                        "placeholder": "Select blood group",
                        "searchable": true,
                        "Json_Attribute": "blood_group",
                        "BindValue": "primary_blood_group",
                        "lookupName": "blood_group",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "contact_details",
                    "title": "Contact Details",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "contact_email",
                        "label": "Email",
                        "placeholder": "Enter email address",
                        "inputType": "email",
                        "required": true,
                        "EnableEmailValidation": true,
                        "Json_Attribute": "email",
                        "BindValue": "contact_email",
                        "columnNumber": "m1 t2 w3",
                        "validation": [
                          {
                            "rule": "required",
                            "message": "Email is required"
                          },
                          {
                            "rule": "email",
                            "message": "Please enter a valid email address"
                          }
                        ]
                      },
                      {
                        "componentType": "textField",
                        "name": "contact_phone",
                        "label": "Mobile",
                        "placeholder": "Enter mobile number",
                        "inputType": "phone",
                        "required": true,
                        "Json_Attribute": "mobile",
                        "BindValue": "contact_phone",
                        "columnNumber": "m1 t2 w3",
                        "validation": [
                          {
                            "rule": "required",
                            "message": "Mobile is required"
                          },
                          {
                            "rule": "pattern",
                            "value": "^[0-9]+$",
                            "message": "Only numbers are allowed"
                          }
                        ]
                      },
                      {
                        "componentType": "textField",
                        "name": "contact_personal_email",
                        "label": "Personal Email",
                        "placeholder": "Enter personal email",
                        "inputType": "email",
                        "EnableEmailValidation": true,
                        "Json_Attribute": "personal_email",
                        "BindValue": "contact_personal_email",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "contact_residence_number",
                        "label": "Residence Number",
                        "placeholder": "Enter residence number",
                        "inputType": "number",
                        "Json_Attribute": "residence_number",
                        "BindValue": "contact_residence_number",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "emergency_contact_1",
                    "title": "Emergency Contact 1",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "emergency_contact_1_name",
                        "label": "Name",
                        "placeholder": "Enter name",
                        "inputType": "text",
                        "Json_Attribute": "emergency_contact_1_name",
                        "BindValue": "emergency_contact_1_name",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "emergency_contact_1_phone",
                        "label": "Mobile Phone",
                        "placeholder": "Enter phone number",
                        "inputType": "phone",
                        "Json_Attribute": "emergency_contact_1_phone",
                        "BindValue": "emergency_contact_1_phone",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textArea",
                        "name": "emergency_contact_1_address",
                        "label": "Address",
                        "placeholder": "Enter address",
                        "rows": 2,
                        "Json_Attribute": "emergency_contact_1_address",
                        "BindValue": "emergency_contact_1_address",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "emergency_contact_1_relationship",
                        "label": "Relationship",
                        "placeholder": "e.g., Father, Mother, Spouse",
                        "inputType": "text",
                        "Json_Attribute": "emergency_contact_1_relationship",
                        "BindValue": "emergency_contact_1_relationship",
                        "lookupName": "emergency_contact_relationship",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "emergency_contact_2",
                    "title": "Emergency Contact 2",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "emergency_contact_2_name",
                        "label": "Name",
                        "placeholder": "Enter name",
                        "inputType": "text",
                        "Json_Attribute": "emergency_contact_2_name",
                        "BindValue": "emergency_contact_2_name",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "emergency_contact_2_phone",
                        "label": "Mobile Phone",
                        "placeholder": "Enter phone number",
                        "inputType": "phone",
                        "Json_Attribute": "emergency_contact_2_phone",
                        "BindValue": "emergency_contact_2_phone",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textArea",
                        "name": "emergency_contact_2_address",
                        "label": "Address",
                        "placeholder": "Enter address",
                        "rows": 2,
                        "Json_Attribute": "emergency_contact_2_address",
                        "BindValue": "emergency_contact_2_address",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "emergency_contact_2_relationship",
                        "label": "Relationship",
                        "placeholder": "e.g., Father, Mother, Spouse",
                        "inputType": "text",
                        "Json_Attribute": "emergency_contact_2_relationship",
                        "BindValue": "emergency_contact_2_relationship",
                        "lookupName": "emergency_contact_relationship",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "addresses",
                    "title": "Addresses",
                    "fields": [
                      {
                        "componentType": "textArea",
                        "name": "address_current_address",
                        "label": "Current Address",
                        "placeholder": "Enter current address",
                        "rows": 4,
                        "maxLength": 250,
                        "Json_Attribute": "current_address",
                        "BindValue": "address_current_address",
                        "columnNumber": "m1 t1 w2",
                        "validation": [
                          {
                            "rule": "maxLength",
                            "value": 250,
                            "message": "Current Address must be at most 250 characters"
                          }
                        ]
                      },
                      {
                        "componentType": "textField",
                        "name": "address_same_as_current",
                        "label": "Same as Current Address",
                        "inputType": "text",
                        "ControlType": "CheckBox",
                        "Json_Attribute": "same_as_current_address",
                        "BindValue": "address_same_as_current",
                        "columnNumber": "m1 t1 w2",
                        "copyFromField": "address_current_address",
                        "copyToField": "address_permanent_address",
                        "disableTargetWhenChecked": true
                      },
                      {
                        "componentType": "textArea",
                        "name": "address_permanent_address",
                        "label": "Permanent Address",
                        "placeholder": "Enter permanent address",
                        "rows": 4,
                        "maxLength": 250,
                        "Json_Attribute": "permanent_address",
                        "BindValue": "address_permanent_address",
                        "columnNumber": "m1 t1 w2",
                        "disabledWhen": "address_same_as_current",
                        "validation": [
                          {
                            "rule": "maxLength",
                            "value": 250,
                            "message": "Permanent Address must be at most 250 characters"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "sectionId": "pan_card",
                    "title": "Identity Information - PAN Card",
                    "enabledForCountries": [
                      "IN"
                    ],
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "pan_number",
                        "label": "Permanent Account Number",
                        "placeholder": "Enter PAN number",
                        "inputType": "text",
                        "Json_Attribute": "pan_number",
                        "BindValue": "pan_number",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "pan_name",
                        "label": "Name on PAN",
                        "placeholder": "Enter name as on PAN",
                        "inputType": "text",
                        "Json_Attribute": "pan_name",
                        "BindValue": "pan_name",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "pan_dob",
                        "label": "Date of Birth (as on PAN)",
                        "placeholder": "Select date",
                        "PreventFutureDateSelection": true,
                        "Json_Attribute": "pan_dob",
                        "BindValue": "pan_dob",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "pan_parent_name",
                        "label": "Parent's Name (as on PAN)",
                        "placeholder": "Enter parent's name",
                        "inputType": "text",
                        "Json_Attribute": "pan_parent_name",
                        "BindValue": "pan_parent_name",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "aadhaar",
                    "title": "Identity Information - Photo ID (Aadhaar)",
                    "enabledForCountries": [
                      "IN"
                    ],
                    "fields": [
                      {
                        "componentType": "selectDropdown",
                        "name": "aadhaar_type",
                        "label": "Photo ID Type",
                        "placeholder": "Select type",
                        "options": [
                          {
                            "label": "Aadhaar",
                            "value": "aadhaar"
                          },
                          {
                            "label": "Driving License",
                            "value": "driving_license"
                          },
                          {
                            "label": "Passport",
                            "value": "passport"
                          },
                          {
                            "label": "Voter ID",
                            "value": "voter_id"
                          }
                        ],
                        "Json_Attribute": "aadhaar_type",
                        "BindValue": "aadhaar_type",
                        "lookupName": "aadhaar_type",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "aadhaar_name",
                        "label": "Name on Photo ID",
                        "placeholder": "Enter name as on ID",
                        "inputType": "text",
                        "Json_Attribute": "aadhaar_name",
                        "BindValue": "aadhaar_name",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "aadhaar_number",
                        "label": "Photo ID Number",
                        "placeholder": "Enter ID number",
                        "inputType": "text",
                        "Json_Attribute": "aadhaar_number",
                        "BindValue": "aadhaar_number",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "aadhaar_dob",
                        "label": "Date of Birth (as on ID)",
                        "placeholder": "Select date",
                        "PreventFutureDateSelection": true,
                        "Json_Attribute": "aadhaar_dob",
                        "BindValue": "aadhaar_dob",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "aadhaar_parent_name",
                        "label": "Parent's Name (as on ID)",
                        "placeholder": "Enter parent's name",
                        "inputType": "text",
                        "Json_Attribute": "aadhaar_parent_name",
                        "BindValue": "aadhaar_parent_name",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "identity_documents",
                    "title": "Identity Documents (Emirates ID, Passport, Visa)",
                    "enabledForCountries": [
                      "UAE",
                      "AE"
                    ],
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "identity_emirates_id",
                        "label": "Emirates ID",
                        "placeholder": "Enter Emirates ID",
                        "inputType": "text",
                        "required": true,
                        "maxLength": 15,
                        "validation": [
                          {
                            "rule": "pattern",
                            "value": "^[a-zA-Z0-9]+$",
                            "message": "Only alphanumeric characters are allowed"
                          },
                          {
                            "rule": "maxLength",
                            "value": 15,
                            "message": "Maximum 15 characters allowed"
                          }
                        ],
                        "Json_Attribute": "emirates_id",
                        "BindValue": "identity_emirates_id",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "identity_emirates_issue_date",
                        "label": "Emirates ID Issue Date",
                        "placeholder": "Select date",
                        "required": true,
                        "PreventFutureDateSelection": true,
                        "Json_Attribute": "emirates_id_issue_date",
                        "BindValue": "identity_emirates_issue_date",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "identity_emirates_expiry_date",
                        "label": "Emirates ID Expiry Date",
                        "placeholder": "Select date",
                        "required": true,
                        "minDateField": "identity_emirates_issue_date",
                        "Json_Attribute": "emirates_id_expiry_date",
                        "BindValue": "identity_emirates_expiry_date",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "identity_passport_no",
                        "label": "Passport No.",
                        "placeholder": "Enter passport number",
                        "inputType": "text",
                        "required": true,
                        "maxLength": 20,
                        "validation": [
                          {
                            "rule": "pattern",
                            "value": "^[a-zA-Z0-9]+$",
                            "message": "Only alphanumeric characters are allowed"
                          },
                          {
                            "rule": "maxLength",
                            "value": 20,
                            "message": "Maximum 20 characters allowed"
                          }
                        ],
                        "Json_Attribute": "passport_no",
                        "BindValue": "identity_passport_no",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "identity_passport_issue_date",
                        "label": "Passport Issue Date",
                        "placeholder": "Select date",
                        "required": true,
                        "PreventFutureDateSelection": true,
                        "Json_Attribute": "passport_issue_date",
                        "BindValue": "identity_passport_issue_date",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "identity_passport_expiry_date",
                        "label": "Passport Expiry Date",
                        "placeholder": "Select date",
                        "required": true,
                        "minDateField": "identity_passport_issue_date",
                        "Json_Attribute": "passport_expiry_date",
                        "BindValue": "identity_passport_expiry_date",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "identity_visa_no",
                        "label": "Visa No",
                        "placeholder": "Enter visa number",
                        "inputType": "text",
                        "required": true,
                        "maxLength": 12,
                        "validation": [
                          {
                            "rule": "pattern",
                            "value": "^[a-zA-Z0-9]+$",
                            "message": "Only alphanumeric characters are allowed"
                          },
                          {
                            "rule": "maxLength",
                            "value": 12,
                            "message": "Maximum 12 characters allowed"
                          }
                        ],
                        "Json_Attribute": "visa_no",
                        "BindValue": "identity_visa_no",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "employment_history",
                    "title": "History of Employment",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "employment_history_previous_company_name",
                        "label": "Name of the Company",
                        "placeholder": "Enter company name",
                        "inputType": "text",
                        "Json_Attribute": "employment_history_previous_company_name",
                        "BindValue": "employment_history_previous_company_name",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "employment_history_previous_employer_id",
                        "label": "Previous Employer ID",
                        "placeholder": "Enter employer ID",
                        "inputType": "text",
                        "Json_Attribute": "employment_history_previous_employer_id",
                        "BindValue": "employment_history_previous_employer_id",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "employment_history_previous_joining_date",
                        "label": "Joining Date",
                        "placeholder": "Select date",
                        "Json_Attribute": "employment_history_previous_joining_date",
                        "BindValue": "employment_history_previous_joining_date",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "employment_history_previous_ending_date",
                        "label": "Ending Date",
                        "placeholder": "Select date",
                        "Json_Attribute": "employment_history_previous_ending_date",
                        "BindValue": "employment_history_previous_ending_date",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "employment_history_total_employment",
                        "label": "Total Duration of Employment",
                        "placeholder": "e.g., 2 years 3 months",
                        "inputType": "text",
                        "Json_Attribute": "employment_history_total_employment",
                        "BindValue": "employment_history_total_employment",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textArea",
                        "name": "employment_history_reason_for_leaving",
                        "label": "Reason for Leaving",
                        "placeholder": "Enter reason for leaving",
                        "rows": 3,
                        "Json_Attribute": "employment_history_reason_for_leaving",
                        "BindValue": "employment_history_reason_for_leaving",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  }
                ]
              },
              "profile": {
                "visibility": [
                  2
                ],
                "sections": [
                  {
                    "sectionId": "about",
                    "title": "About",
                    "fields": [
                      {
                        "componentType": "textArea",
                        "name": "about",
                        "label": "About",
                        "placeholder": "Tell us about yourself...",
                        "rows": 4,
                        "Json_Attribute": "about",
                        "BindValue": "about",
                        "columnNumber": "m1 t1 w1"
                      }
                    ]
                  },
                  {
                    "sectionId": "what_i_love",
                    "title": "What I love about my job?",
                    "fields": [
                      {
                        "componentType": "textArea",
                        "name": "what_i_love",
                        "label": "What I love about my job?",
                        "placeholder": "What do you love about your job?",
                        "rows": 4,
                        "Json_Attribute": "what_i_love",
                        "BindValue": "what_i_love",
                        "columnNumber": "m1 t1 w1"
                      }
                    ]
                  },
                  {
                    "sectionId": "interests",
                    "title": "My interests and hobbies",
                    "fields": [
                      {
                        "componentType": "textArea",
                        "name": "interests",
                        "label": "My interests and hobbies",
                        "placeholder": "Share your interests and hobbies...",
                        "rows": 4,
                        "Json_Attribute": "interests",
                        "BindValue": "interests",
                        "columnNumber": "m1 t1 w1"
                      }
                    ]
                  }
                ]
              },
              "job": {
                "visibility": [
                  1,
                  2
                ],
                "sections": [
                  {
                    "sectionId": "job_details",
                    "title": "Job Details",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "job_employee_number",
                        "label": "Employee Number",
                        "placeholder": "Enter employee number",
                        "inputType": "number",
                        "Json_Attribute": "employee_number",
                        "BindValue": "job_employee_number",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "job_date_of_joining",
                        "label": "Date of Joining",
                        "placeholder": "Select date",
                        "required": true,
                        "Json_Attribute": "date_of_joining",
                        "BindValue": "job_date_of_joining",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "job_job_title_primary",
                        "label": "Job Title - Primary",
                        "placeholder": "Enter primary job title",
                        "inputType": "text",
                        "Json_Attribute": "job_title_primary",
                        "BindValue": "job_job_title_primary",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "job_job_title_secondary",
                        "label": "Job Title - Secondary",
                        "placeholder": "Enter secondary job title",
                        "inputType": "text",
                        "Json_Attribute": "job_title_secondary",
                        "BindValue": "job_job_title_secondary",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "job_in_probation",
                        "label": "In Probation?",
                        "placeholder": "Enter probation details",
                        "inputType": "text",
                        "Json_Attribute": "job_in_probation",
                        "BindValue": "job_in_probation",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "job_notice_period",
                        "label": "Notice Period",
                        "placeholder": "Enter notice period",
                        "inputType": "text",
                        "Json_Attribute": "job_notice_period",
                        "BindValue": "job_notice_period",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "job_worker_type",
                        "label": "Worker Type",
                        "placeholder": "Select worker type",
                        "options": [
                          {
                            "label": "Permanent",
                            "value": "permanent"
                          },
                          {
                            "label": "Contract",
                            "value": "contract"
                          },
                          {
                            "label": "Temporary",
                            "value": "temporary"
                          }
                        ],
                        "Json_Attribute": "job_worker_type",
                        "BindValue": "job_worker_type",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "job_time_type",
                        "label": "Time Type",
                        "placeholder": "Select time type",
                        "options": [
                          {
                            "label": "Full Time",
                            "value": "fulltime"
                          },
                          {
                            "label": "Part Time",
                            "value": "parttime"
                          }
                        ],
                        "Json_Attribute": "job_time_type",
                        "BindValue": "job_time_type",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "job_contract_status",
                        "label": "Contract Status",
                        "placeholder": "Enter contract status",
                        "inputType": "text",
                        "Json_Attribute": "job_contract_status",
                        "BindValue": "job_contract_status",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "job_pay_band",
                        "label": "Pay Band",
                        "placeholder": "Enter pay band",
                        "inputType": "text",
                        "Json_Attribute": "job_pay_band",
                        "BindValue": "job_pay_band",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "job_pay_grade",
                        "label": "Pay Grade",
                        "placeholder": "Enter pay grade",
                        "inputType": "text",
                        "Json_Attribute": "job_pay_grade",
                        "BindValue": "job_pay_grade",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "organization",
                    "title": "Organization",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "organization_business_unit",
                        "label": "Business Unit",
                        "placeholder": "Enter business unit",
                        "inputType": "text",
                        "Json_Attribute": "organization_business_unit",
                        "BindValue": "organization_business_unit",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "searchableDropdown",
                        "name": "organization_group_id",
                        "label": "Group",
                        "placeholder": "Select group",
                        "searchable": true,
                        "required": true,
                        "lookupName": "employee_group",
                        "Json_Attribute": "group_id",
                        "BindValue": "organization_group_id",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "organization_location",
                        "label": "Location",
                        "placeholder": "Enter location",
                        "inputType": "text",
                        "Json_Attribute": "organization_location",
                        "BindValue": "organization_location",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "organization_cost_center",
                        "label": "Cost Center",
                        "placeholder": "Enter cost center",
                        "inputType": "text",
                        "Json_Attribute": "organization_cost_center",
                        "BindValue": "organization_cost_center",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "organization_legal_entity",
                        "label": "Legal Entity",
                        "placeholder": "Enter legal entity",
                        "inputType": "text",
                        "Json_Attribute": "organization_legal_entity",
                        "BindValue": "organization_legal_entity",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "searchableDropdown",
                        "name": "organization_reports_to",
                        "label": "Reports To",
                        "placeholder": "Select reporting manager",
                        "searchable": true,
                        "lookupName": "admin_employees",
                        "Json_Attribute": "reports_to",
                        "BindValue": "organization_reports_to",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "searchableDropdown",
                        "name": "organization_manager_of_manager",
                        "label": "Manager of Manager (L2 Manager)",
                        "placeholder": "Select L2 manager",
                        "searchable": true,
                        "Json_Attribute": "organization_manager_of_manager",
                        "BindValue": "organization_manager_of_manager",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "organization_direct_reports",
                        "label": "Direct Reports",
                        "placeholder": "Enter number of direct reports",
                        "inputType": "number",
                        "Json_Attribute": "organization_direct_reports",
                        "BindValue": "organization_direct_reports",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "searchableDropdown",
                        "name": "organization_visa_branch",
                        "label": "Visa Branch",
                        "placeholder": "Select visa branch",
                        "searchable": true,
                        "required": true,
                        "lookupName": "branches",
                        "Json_Attribute": "visa_branch",
                        "BindValue": "organization_visa_branch",
                        "columnNumber": "m1 t2 w3"
                      }
                    
                    ]
                  },
                  {
                    "sectionId": "employee_time",
                    "title": "Employee Time",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "employee_time_shift",
                        "label": "Shift",
                        "placeholder": "Enter shift",
                        "inputType": "text",
                        "Json_Attribute": "employee_time_shift",
                        "BindValue": "employee_time_shift",
                        "columnNumber": "m1 t2 w3",
                        "isReadOnly": true,
                        "disabled": true
                      },
                      {
                        "componentType": "textField",
                        "name": "employee_time_weekly_off_policy",
                        "label": "Weekly Off Policy",
                        "placeholder": "Enter weekly off policy",
                        "inputType": "text",
                        "Json_Attribute": "employee_time_weekly_off_policy",
                        "BindValue": "employee_time_weekly_off_policy",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "employee_time_leave_plan",
                        "label": "Leave Plan",
                        "placeholder": "Enter leave plan",
                        "inputType": "text",
                        "Json_Attribute": "employee_time_leave_plan",
                        "BindValue": "employee_time_leave_plan",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "employee_time_holiday_calendar",
                        "label": "Holiday Calendar",
                        "placeholder": "Enter holiday calendar",
                        "inputType": "text",
                        "Json_Attribute": "employee_time_holiday_calendar",
                        "BindValue": "employee_time_holiday_calendar",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "employee_time_attendance_number",
                        "label": "Attendance Number",
                        "placeholder": "Enter attendance number",
                        "inputType": "number",
                        "Json_Attribute": "employee_time_attendance_number",
                        "BindValue": "employee_time_attendance_number",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "employee_time_attendance_capture_scheme",
                        "label": "Attendance Capture Scheme",
                        "placeholder": "Enter attendance capture scheme",
                        "inputType": "text",
                        "Json_Attribute": "employee_time_attendance_capture_scheme",
                        "BindValue": "employee_time_attendance_capture_scheme",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "employee_time_attendance_penalization_policy",
                        "label": "Attendance Penalization Policy",
                        "placeholder": "Enter attendance penalization policy",
                        "inputType": "text",
                        "Json_Attribute": "employee_time_attendance_penalization_policy",
                        "BindValue": "employee_time_attendance_penalization_policy",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "employee_time_shift_weekly_off_rule",
                        "label": "Shift Weekly Off Rule",
                        "placeholder": "Enter shift weekly off rule",
                        "inputType": "text",
                        "Json_Attribute": "employee_time_shift_weekly_off_rule",
                        "BindValue": "employee_time_shift_weekly_off_rule",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "employee_time_shift_allowance_policy",
                        "label": "Shift Allowance Policy",
                        "placeholder": "Enter shift allowance policy",
                        "inputType": "text",
                        "Json_Attribute": "employee_time_shift_allowance_policy",
                        "BindValue": "employee_time_shift_allowance_policy",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "employee_time_overtime",
                        "label": "Overtime",
                        "placeholder": "Enter overtime policy",
                        "inputType": "text",
                        "Json_Attribute": "employee_time_overtime",
                        "BindValue": "employee_time_overtime",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "other",
                    "title": "Other",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "other_expense_policy",
                        "label": "Expense Policy",
                        "placeholder": "Enter expense policy",
                        "inputType": "text",
                        "Json_Attribute": "other_expense_policy",
                        "BindValue": "other_expense_policy",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "other_loan_policy",
                        "label": "Loan Policy",
                        "placeholder": "Enter loan policy",
                        "inputType": "text",
                        "Json_Attribute": "other_loan_policy",
                        "BindValue": "other_loan_policy",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "other_air_ticket_policy",
                        "label": "Air Ticket Policy",
                        "placeholder": "Enter air ticket policy",
                        "inputType": "text",
                        "Json_Attribute": "other_air_ticket_policy",
                        "BindValue": "other_air_ticket_policy",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "other_sales_included",
                        "label": "Include sales",
                        "placeholder": "",
                        "inputType": "text",
                        "ControlType": "CheckBox",
                        "Json_Attribute": "sales_included",
                        "BindValue": "other_sales_included",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "other_user_access",
                        "label": "Enable user",
                        "placeholder": "",
                        "inputType": "text",
                        "ControlType": "CheckBox",
                        "Json_Attribute": "user_access",
                        "BindValue": "other_user_access",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  }
                ]
              },
              "documents": {
                "visibility": [
                  2
                ],
                "sections": [
                  {
                    "sectionId": "upload_documents",
                    "title": "Upload Documents",
                    "fields": [
                      {
                        "componentType": "imageUpload",
                        "name": "document_aadhaar",
                        "label": "Aadhaar Card",
                        "maxFiles": 1,
                        "acceptedFileTypes": [
                          "image/jpeg",
                          "image/png",
                          "application/pdf"
                        ],
                        "previewEnabled": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "imageUpload",
                        "name": "document_pan",
                        "label": "PAN Card",
                        "maxFiles": 1,
                        "acceptedFileTypes": [
                          "image/jpeg",
                          "image/png",
                          "application/pdf"
                        ],
                        "previewEnabled": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "imageUpload",
                        "name": "document_voter_id",
                        "label": "Voter ID Card",
                        "maxFiles": 1,
                        "acceptedFileTypes": [
                          "image/jpeg",
                          "image/png",
                          "application/pdf"
                        ],
                        "previewEnabled": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "imageUpload",
                        "name": "document_driving_license",
                        "label": "Driving License",
                        "maxFiles": 1,
                        "acceptedFileTypes": [
                          "image/jpeg",
                          "image/png",
                          "application/pdf"
                        ],
                        "previewEnabled": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "imageUpload",
                        "name": "document_passport",
                        "label": "Passport",
                        "maxFiles": 1,
                        "acceptedFileTypes": [
                          "image/jpeg",
                          "image/png",
                          "application/pdf"
                        ],
                        "previewEnabled": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "imageUpload",
                        "name": "document_degrees",
                        "label": "Degrees & Certificates",
                        "maxFiles": 5,
                        "acceptedFileTypes": [
                          "image/jpeg",
                          "image/png",
                          "application/pdf"
                        ],
                        "previewEnabled": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "imageUpload",
                        "name": "document_10th",
                        "label": "10th Certificate",
                        "maxFiles": 1,
                        "acceptedFileTypes": [
                          "image/jpeg",
                          "image/png",
                          "application/pdf"
                        ],
                        "previewEnabled": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "imageUpload",
                        "name": "document_12th",
                        "label": "12th Certificate",
                        "maxFiles": 1,
                        "acceptedFileTypes": [
                          "image/jpeg",
                          "image/png",
                          "application/pdf"
                        ],
                        "previewEnabled": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "imageUpload",
                        "name": "document_experience_letter",
                        "label": "Experience Letter",
                        "maxFiles": 5,
                        "acceptedFileTypes": [
                          "image/jpeg",
                          "image/png",
                          "application/pdf"
                        ],
                        "previewEnabled": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "imageUpload",
                        "name": "document_relieving_letter",
                        "label": "Relieving Letter",
                        "maxFiles": 5,
                        "acceptedFileTypes": [
                          "image/jpeg",
                          "image/png",
                          "application/pdf"
                        ],
                        "previewEnabled": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "imageUpload",
                        "name": "document_payslip",
                        "label": "3 Months Payslip",
                        "maxFiles": 3,
                        "acceptedFileTypes": [
                          "image/jpeg",
                          "image/png",
                          "application/pdf"
                        ],
                        "previewEnabled": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "imageUpload",
                        "name": "document_bank_details",
                        "label": "Bank Details",
                        "maxFiles": 1,
                        "acceptedFileTypes": [
                          "image/jpeg",
                          "image/png",
                          "application/pdf"
                        ],
                        "previewEnabled": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "imageUpload",
                        "name": "document_passport_photo",
                        "label": "Passport Size Colour Picture",
                        "maxFiles": 1,
                        "acceptedFileTypes": [
                          "image/jpeg",
                          "image/png"
                        ],
                        "previewEnabled": true,
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  }
                ]
              },
              "assets": {
                "visibility": [
                  1,
                  2
                ],
                "sections": [
                  {
                    "sectionId": "assign_assets",
                    "title": "Assign Assets",
                    "fields": [
                      {
                        "componentType": "searchableDropdown",
                        "name": "asset_type",
                        "label": "Asset Type",
                        "placeholder": "Select asset type",
                        "searchable": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "searchableDropdown",
                        "name": "asset_name",
                        "label": "Asset Name",
                        "placeholder": "Select asset",
                        "searchable": true,
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "asset_category",
                        "label": "Asset Category",
                        "placeholder": "Enter asset category",
                        "inputType": "text",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "asset_assigned_on",
                        "label": "Assigned On",
                        "placeholder": "Select date",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "asset_acknowledgement_status",
                        "label": "Acknowledgement Status",
                        "placeholder": "Select status",
                        "options": [
                          {
                            "label": "Acknowledged",
                            "value": "acknowledged"
                          },
                          {
                            "label": "Pending",
                            "value": "pending"
                          },
                          {
                            "label": "Not Applicable",
                            "value": "not_applicable"
                          }
                        ],
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "asset_latest_condition",
                        "label": "Latest Condition",
                        "placeholder": "Select condition",
                        "options": [
                          {
                            "label": "Good",
                            "value": "good"
                          },
                          {
                            "label": "Fair",
                            "value": "fair"
                          },
                          {
                            "label": "Poor",
                            "value": "poor"
                          },
                          {
                            "label": "Damaged",
                            "value": "damaged"
                          }
                        ],
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  }
                ]
              },
              "salary": {
                "visibility": [
                  1,
                  2
                ],
                "sections": [
                  {
                    "sectionId": "basic_salary_info",
                    "title": "Basic Salary Information",
                    "fields": [
                      {
                        "componentType": "searchableDropdown",
                        "name": "salary_currency",
                        "label": "Currency",
                        "placeholder": "Select currency",
                        "searchable": true,
                        "required": true,
                        "lookupName": "currency",
                        "Json_Attribute": "currency",
                        "BindValue": "salary_currency",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "salary_frequency",
                        "label": "Salary Frequency",
                        "placeholder": "Select frequency",
                        "options": [
                          {
                            "label": "Monthly",
                            "value": "monthly"
                          },
                          {
                            "label": "Weekly",
                            "value": "weekly"
                          },
                          {
                            "label": "Daily",
                            "value": "daily"
                          }
                        ],
                        "Json_Attribute": "salary_frequency",
                        "BindValue": "salary_frequency",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "salary_effective_date",
                        "label": "Effective Date",
                        "placeholder": "Select date",
                        "required": true,
                        "Json_Attribute": "effective_date",
                        "BindValue": "salary_effective_date",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "allowances",
                    "title": "Allowances",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "salary_housing_allowance",
                        "label": "Housing Allowance",
                        "placeholder": "Enter housing allowance",
                        "inputType": "number",
                        "Json_Attribute": "housing_allowance",
                        "BindValue": "salary_housing_allowance",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_transport_allowance",
                        "label": "Transport Allowance",
                        "placeholder": "Enter transport allowance",
                        "inputType": "number",
                        "Json_Attribute": "transport_allowance",
                        "BindValue": "salary_transport_allowance",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_food_allowance",
                        "label": "Food Allowance",
                        "placeholder": "Enter food allowance",
                        "inputType": "number",
                        "Json_Attribute": "food_allowance",
                        "BindValue": "salary_food_allowance",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_medical_allowance",
                        "label": "Medical Allowance",
                        "placeholder": "Enter medical allowance",
                        "inputType": "number",
                        "Json_Attribute": "medical_allowance",
                        "BindValue": "salary_medical_allowance",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_other_allowances",
                        "label": "Other Allowances",
                        "placeholder": "Enter other allowances",
                        "inputType": "number",
                        "Json_Attribute": "other_allowances",
                        "BindValue": "salary_other_allowances",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_total_allowances",
                        "label": "Total Allowances",
                        "placeholder": "Auto-calculated",
                        "inputType": "number",
                        "isReadOnly": true,
                        "disabled": true,
                        "Json_Attribute": "total_allowances",
                        "BindValue": "salary_total_allowances",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "deductions",
                    "title": "Deductions",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "salary_income_tax",
                        "label": "Income Tax",
                        "placeholder": "Enter income tax",
                        "inputType": "number",
                        "Json_Attribute": "income_tax",
                        "BindValue": "salary_income_tax",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_provident_fund",
                        "label": "Provident Fund",
                        "placeholder": "Enter provident fund",
                        "inputType": "number",
                        "Json_Attribute": "provident_fund",
                        "BindValue": "salary_provident_fund",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_insurance",
                        "label": "Insurance",
                        "placeholder": "Enter insurance",
                        "inputType": "number",
                        "Json_Attribute": "insurance",
                        "BindValue": "salary_insurance",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_other_deductions",
                        "label": "Other Deductions",
                        "placeholder": "Enter other deductions",
                        "inputType": "number",
                        "Json_Attribute": "other_deductions",
                        "BindValue": "salary_other_deductions",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_total_deductions",
                        "label": "Total Deductions",
                        "placeholder": "Auto-calculated",
                        "inputType": "number",
                        "isReadOnly": true,
                        "disabled": true,
                        "Json_Attribute": "total_deductions",
                        "BindValue": "salary_total_deductions",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "salary_summary",
                    "title": "Salary Summary",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "salary_gross_salary",
                        "label": "Gross Salary",
                        "placeholder": "Enter gross salary",
                        "inputType": "number",
                        "required": true,
                        "Json_Attribute": "gross_salary",
                        "BindValue": "salary_gross_salary",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_basic_salary",
                        "label": "Basic Salary (50%)",
                        "placeholder": "Auto-calculated (50% of Gross)",
                        "inputType": "number",
                        "isReadOnly": true,
                        "disabled": true,
                        "Json_Attribute": "basic_salary",
                        "BindValue": "salary_basic_salary",
                        "columnNumber": "m1 t2 w3",
                        "ExpressionV2": "[salary_gross_salary] * 0.5"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_housing_allowance",
                        "label": "HRA (35%)",
                        "placeholder": "Auto-calculated (35% of Gross)",
                        "inputType": "number",
                        "isReadOnly": true,
                        "disabled": true,
                        "Json_Attribute": "housing_allowance",
                        "BindValue": "salary_housing_allowance",
                        "columnNumber": "m1 t2 w3",
                        "ExpressionV2": "[salary_gross_salary] * 0.35"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_other_allowances",
                        "label": "Other Allowances (15%)",
                        "placeholder": "Auto-calculated (15% of Gross)",
                        "inputType": "number",
                        "isReadOnly": true,
                        "disabled": true,
                        "Json_Attribute": "other_allowances",
                        "BindValue": "salary_other_allowances",
                        "columnNumber": "m1 t2 w3",
                        "ExpressionV2": "[salary_gross_salary] * 0.15"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_net_salary",
                        "label": "Net Salary",
                        "placeholder": "Auto-calculated",
                        "inputType": "number",
                        "isReadOnly": true,
                        "disabled": true,
                        "Json_Attribute": "net_salary",
                        "BindValue": "salary_net_salary",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_per_day_salary",
                        "label": "Per Day Salary",
                        "placeholder": "Auto-calculated (Gross Salary / Days)",
                        "inputType": "number",
                        "isReadOnly": true,
                        "disabled": true,
                        "Json_Attribute": "per_day_salary",
                        "BindValue": "salary_per_day_salary",
                        "columnNumber": "m1 t2 w3",
                        "ExpressionV2": "[salary_gross_salary]/30"
                      }
                    ]
                  },
                  {
                    "sectionId": "bank_details",
                    "title": "Bank Details for Salary Transfer",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "salary_bank_name",
                        "label": "Bank Name",
                        "placeholder": "Enter bank name",
                        "inputType": "text",
                        "required": true,
                        "Json_Attribute": "bank_name",
                        "BindValue": "salary_bank_name",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_bank_account_number",
                        "label": "Account Number",
                        "placeholder": "Enter account number",
                        "inputType": "text",
                        "required": true,
                        "Json_Attribute": "bank_account_number",
                        "BindValue": "salary_bank_account_number",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_bank_ifsc_code",
                        "label": "IFSC Code",
                        "placeholder": "Enter IFSC code",
                        "inputType": "text",
                        "required": true,
                        "Json_Attribute": "bank_ifsc_code",
                        "BindValue": "salary_bank_ifsc_code",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_bank_branch_name",
                        "label": "Branch Name",
                        "placeholder": "Enter branch name",
                        "inputType": "text",
                        "required": false,
                        "Json_Attribute": "bank_branch_name",
                        "BindValue": "salary_bank_branch_name",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "salary_bank_account_type",
                        "label": "Account Type",
                        "placeholder": "Select account type",
                        "required": true,
                        "options": [
                          {
                            "label": "Savings",
                            "value": "savings"
                          },
                          {
                            "label": "Current",
                            "value": "current"
                          }
                        ],
                        "Json_Attribute": "bank_account_type",
                        "BindValue": "salary_bank_account_type",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "additional_info",
                    "title": "Additional Salary Information",
                    "fields": [
                      {
                        "componentType": "textField",
                        "name": "salary_pay_grade",
                        "label": "Pay Grade",
                        "placeholder": "Enter pay grade",
                        "inputType": "text",
                        "Json_Attribute": "pay_grade",
                        "BindValue": "salary_pay_grade",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_pay_scale",
                        "label": "Pay Scale",
                        "placeholder": "Enter pay scale",
                        "inputType": "text",
                        "Json_Attribute": "pay_scale",
                        "BindValue": "salary_pay_scale",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "salary_increment_date",
                        "label": "Last Increment Date",
                        "placeholder": "Select date",
                        "Json_Attribute": "increment_date",
                        "BindValue": "salary_increment_date",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "dateField",
                        "name": "salary_next_increment_date",
                        "label": "Next Increment Date",
                        "placeholder": "Select date",
                        "Json_Attribute": "next_increment_date",
                        "BindValue": "salary_next_increment_date",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_increment_percentage",
                        "label": "Increment Percentage",
                        "placeholder": "Enter percentage",
                        "inputType": "number",
                        "Json_Attribute": "increment_percentage",
                        "BindValue": "salary_increment_percentage",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "salary_bonus_eligibility",
                        "label": "Bonus Eligibility",
                        "placeholder": "Select",
                        "options": [
                          {
                            "label": "Yes",
                            "value": "yes"
                          },
                          {
                            "label": "No",
                            "value": "no"
                          }
                        ],
                        "Json_Attribute": "bonus_eligibility",
                        "BindValue": "salary_bonus_eligibility",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "salary_bonus_percentage",
                        "label": "Bonus Percentage",
                        "placeholder": "Enter bonus percentage",
                        "inputType": "number",
                        "Json_Attribute": "bonus_percentage",
                        "BindValue": "salary_bonus_percentage",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  }
                ]
              },
              "leave": {
                "visibility": [
                  1,
                  2
                ],
                "sections": [
                  {
                    "sectionId": "bereavement_leave",
                    "title": "Bereavement Leave",
                    "fields": [
                      {
                        "componentType": "selectDropdown",
                        "name": "leave_bereavement_allocated_days",
                        "label": "Leave Balance (Days)",
                        "placeholder": "Select days",
                        "options": [
                          {
                            "label": "0",
                            "value": "0"
                          },
                          {
                            "label": "1",
                            "value": "1"
                          },
                          {
                            "label": "2",
                            "value": "2"
                          },
                          {
                            "label": "3",
                            "value": "3"
                          },
                          {
                            "label": "4",
                            "value": "4"
                          },
                          {
                            "label": "5",
                            "value": "5"
                          },
                          {
                            "label": "6",
                            "value": "6"
                          },
                          {
                            "label": "7",
                            "value": "7"
                          },
                          {
                            "label": "8",
                            "value": "8"
                          },
                          {
                            "label": "9",
                            "value": "9"
                          },
                          {
                            "label": "10",
                            "value": "10"
                          },
                          {
                            "label": "11",
                            "value": "11"
                          },
                          {
                            "label": "12",
                            "value": "12"
                          }
                        ],
                        "Json_Attribute": "bereavement_allocated_days",
                        "BindValue": "leave_bereavement_allocated_days",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "leave_bereavement_carryover_enabled",
                        "label": "Carryover Enabled",
                        "placeholder": "Select",
                        "options": [
                          {
                            "label": "Yes",
                            "value": "yes"
                          },
                          {
                            "label": "No",
                            "value": "no"
                          }
                        ],
                        "Json_Attribute": "bereavement_carryover_enabled",
                        "BindValue": "leave_bereavement_carryover_enabled",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "leave_bereavement_carry_forward_days",
                        "label": "Carry Forward Days",
                        "placeholder": "Enter carry forward days",
                        "inputType": "number",
                        "Json_Attribute": "bereavement_carry_forward_days",
                        "BindValue": "leave_bereavement_carry_forward_days",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "casual_leave",
                    "title": "Casual Leave",
                    "fields": [
                      {
                        "componentType": "selectDropdown",
                        "name": "leave_casual_allocated_days",
                        "label": "Leave Balance (Days)",
                        "placeholder": "Select days",
                        "options": [
                          {
                            "label": "0",
                            "value": "0"
                          },
                          {
                            "label": "1",
                            "value": "1"
                          },
                          {
                            "label": "2",
                            "value": "2"
                          },
                          {
                            "label": "3",
                            "value": "3"
                          },
                          {
                            "label": "4",
                            "value": "4"
                          },
                          {
                            "label": "5",
                            "value": "5"
                          },
                          {
                            "label": "6",
                            "value": "6"
                          },
                          {
                            "label": "7",
                            "value": "7"
                          },
                          {
                            "label": "8",
                            "value": "8"
                          },
                          {
                            "label": "9",
                            "value": "9"
                          },
                          {
                            "label": "10",
                            "value": "10"
                          },
                          {
                            "label": "11",
                            "value": "11"
                          },
                          {
                            "label": "12",
                            "value": "12"
                          }
                        ],
                        "Json_Attribute": "casual_allocated_days",
                        "BindValue": "leave_casual_allocated_days",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "leave_casual_carryover_enabled",
                        "label": "Carryover Enabled",
                        "placeholder": "Select",
                        "options": [
                          {
                            "label": "Yes",
                            "value": "yes"
                          },
                          {
                            "label": "No",
                            "value": "no"
                          }
                        ],
                        "Json_Attribute": "casual_carryover_enabled",
                        "BindValue": "leave_casual_carryover_enabled",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "leave_casual_carry_forward_days",
                        "label": "Carry Forward Days",
                        "placeholder": "Enter carry forward days",
                        "inputType": "number",
                        "Json_Attribute": "casual_carry_forward_days",
                        "BindValue": "leave_casual_carry_forward_days",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "comp_offs",
                    "title": "Comp Offs",
                    "fields": [
                      {
                        "componentType": "selectDropdown",
                        "name": "leave_comp_offs_allocated_days",
                        "label": "Leave Balance (Days)",
                        "placeholder": "Select days",
                        "options": [
                          {
                            "label": "0",
                            "value": "0"
                          },
                          {
                            "label": "1",
                            "value": "1"
                          },
                          {
                            "label": "2",
                            "value": "2"
                          },
                          {
                            "label": "3",
                            "value": "3"
                          },
                          {
                            "label": "4",
                            "value": "4"
                          },
                          {
                            "label": "5",
                            "value": "5"
                          },
                          {
                            "label": "6",
                            "value": "6"
                          },
                          {
                            "label": "7",
                            "value": "7"
                          },
                          {
                            "label": "8",
                            "value": "8"
                          },
                          {
                            "label": "9",
                            "value": "9"
                          },
                          {
                            "label": "10",
                            "value": "10"
                          },
                          {
                            "label": "11",
                            "value": "11"
                          },
                          {
                            "label": "12",
                            "value": "12"
                          }
                        ],
                        "Json_Attribute": "comp_offs_allocated_days",
                        "BindValue": "leave_comp_offs_allocated_days",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "leave_comp_offs_carryover_enabled",
                        "label": "Carryover Enabled",
                        "placeholder": "Select",
                        "options": [
                          {
                            "label": "Yes",
                            "value": "yes"
                          },
                          {
                            "label": "No",
                            "value": "no"
                          }
                        ],
                        "Json_Attribute": "comp_offs_carryover_enabled",
                        "BindValue": "leave_comp_offs_carryover_enabled",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "leave_comp_offs_carry_forward_days",
                        "label": "Carry Forward Days",
                        "placeholder": "Enter carry forward days",
                        "inputType": "number",
                        "Json_Attribute": "comp_offs_carry_forward_days",
                        "BindValue": "leave_comp_offs_carry_forward_days",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "paternity_leave",
                    "title": "Paternity Leave",
                    "fields": [
                      {
                        "componentType": "selectDropdown",
                        "name": "leave_paternity_allocated_days",
                        "label": "Leave Balance (Days)",
                        "placeholder": "Select days",
                        "options": [
                          {
                            "label": "0",
                            "value": "0"
                          },
                          {
                            "label": "1",
                            "value": "1"
                          },
                          {
                            "label": "2",
                            "value": "2"
                          },
                          {
                            "label": "3",
                            "value": "3"
                          },
                          {
                            "label": "4",
                            "value": "4"
                          },
                          {
                            "label": "5",
                            "value": "5"
                          },
                          {
                            "label": "6",
                            "value": "6"
                          },
                          {
                            "label": "7",
                            "value": "7"
                          },
                          {
                            "label": "8",
                            "value": "8"
                          },
                          {
                            "label": "9",
                            "value": "9"
                          },
                          {
                            "label": "10",
                            "value": "10"
                          },
                          {
                            "label": "11",
                            "value": "11"
                          },
                          {
                            "label": "12",
                            "value": "12"
                          }
                        ],
                        "Json_Attribute": "paternity_allocated_days",
                        "BindValue": "leave_paternity_allocated_days",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "leave_paternity_carryover_enabled",
                        "label": "Carryover Enabled",
                        "placeholder": "Select",
                        "options": [
                          {
                            "label": "Yes",
                            "value": "yes"
                          },
                          {
                            "label": "No",
                            "value": "no"
                          }
                        ],
                        "Json_Attribute": "paternity_carryover_enabled",
                        "BindValue": "leave_paternity_carryover_enabled",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "leave_paternity_carry_forward_days",
                        "label": "Carry Forward Days",
                        "placeholder": "Enter carry forward days",
                        "inputType": "number",
                        "Json_Attribute": "paternity_carry_forward_days",
                        "BindValue": "leave_paternity_carry_forward_days",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "privilege_casual_leave",
                    "title": "Privilege Casual Leave",
                    "fields": [
                      {
                        "componentType": "selectDropdown",
                        "name": "leave_privilege_casual_allocated_days",
                        "label": "Leave Balance (Days)",
                        "placeholder": "Select days",
                        "options": [
                          {
                            "label": "0",
                            "value": "0"
                          },
                          {
                            "label": "1",
                            "value": "1"
                          },
                          {
                            "label": "2",
                            "value": "2"
                          },
                          {
                            "label": "3",
                            "value": "3"
                          },
                          {
                            "label": "4",
                            "value": "4"
                          },
                          {
                            "label": "5",
                            "value": "5"
                          },
                          {
                            "label": "6",
                            "value": "6"
                          },
                          {
                            "label": "7",
                            "value": "7"
                          },
                          {
                            "label": "8",
                            "value": "8"
                          },
                          {
                            "label": "9",
                            "value": "9"
                          },
                          {
                            "label": "10",
                            "value": "10"
                          },
                          {
                            "label": "11",
                            "value": "11"
                          },
                          {
                            "label": "12",
                            "value": "12"
                          }
                        ],
                        "Json_Attribute": "privilege_casual_allocated_days",
                        "BindValue": "leave_privilege_casual_allocated_days",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "leave_privilege_casual_carryover_enabled",
                        "label": "Carryover Enabled",
                        "placeholder": "Select",
                        "options": [
                          {
                            "label": "Yes",
                            "value": "yes"
                          },
                          {
                            "label": "No",
                            "value": "no"
                          }
                        ],
                        "Json_Attribute": "privilege_casual_carryover_enabled",
                        "BindValue": "leave_privilege_casual_carryover_enabled",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "leave_privilege_casual_carry_forward_days",
                        "label": "Carry Forward Days",
                        "placeholder": "Enter carry forward days",
                        "inputType": "number",
                        "Json_Attribute": "privilege_casual_carry_forward_days",
                        "BindValue": "leave_privilege_casual_carry_forward_days",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  },
                  {
                    "sectionId": "sick_leave",
                    "title": "Sick Leave",
                    "fields": [
                      {
                        "componentType": "selectDropdown",
                        "name": "leave_sick_allocated_days",
                        "label": "Leave Balance (Days)",
                        "placeholder": "Select days",
                        "options": [
                          {
                            "label": "0",
                            "value": "0"
                          },
                          {
                            "label": "1",
                            "value": "1"
                          },
                          {
                            "label": "2",
                            "value": "2"
                          },
                          {
                            "label": "3",
                            "value": "3"
                          },
                          {
                            "label": "4",
                            "value": "4"
                          },
                          {
                            "label": "5",
                            "value": "5"
                          },
                          {
                            "label": "6",
                            "value": "6"
                          },
                          {
                            "label": "7",
                            "value": "7"
                          },
                          {
                            "label": "8",
                            "value": "8"
                          },
                          {
                            "label": "9",
                            "value": "9"
                          },
                          {
                            "label": "10",
                            "value": "10"
                          },
                          {
                            "label": "11",
                            "value": "11"
                          },
                          {
                            "label": "12",
                            "value": "12"
                          }
                        ],
                        "Json_Attribute": "sick_allocated_days",
                        "BindValue": "leave_sick_allocated_days",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "selectDropdown",
                        "name": "leave_sick_carryover_enabled",
                        "label": "Carryover Enabled",
                        "placeholder": "Select",
                        "options": [
                          {
                            "label": "Yes",
                            "value": "yes"
                          },
                          {
                            "label": "No",
                            "value": "no"
                          }
                        ],
                        "Json_Attribute": "sick_carryover_enabled",
                        "BindValue": "leave_sick_carryover_enabled",
                        "columnNumber": "m1 t2 w3"
                      },
                      {
                        "componentType": "textField",
                        "name": "leave_sick_carry_forward_days",
                        "label": "Carry Forward Days",
                        "placeholder": "Enter carry forward days",
                        "inputType": "number",
                        "Json_Attribute": "sick_carry_forward_days",
                        "BindValue": "leave_sick_carry_forward_days",
                        "columnNumber": "m1 t2 w3"
                      }
                    ]
                  }
                ]
              }
            }
          }
        }
      ]
    }
  ];
